import React, { Fragment } from 'react';
import { Divider } from '@infoods/lifebase-ui';

import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded';

import classes from './CoachPerformanceList.module.scss';
import { CoachPerformanceData } from '../../../../interfaces/entity-dashboard/CoachPerformanceData';
import { CoachPerformanceItem } from './CoachPerformanceItem/CoachPerformanceItem';
import { WidgetEmptyPlaceholder } from '../../../../../shared/components/ui-components';

type CoachPerformanceListProps = {
  coachPerformanceItems: CoachPerformanceData[] | null;
};

const CoachPerformanceList = ({ coachPerformanceItems }: CoachPerformanceListProps) => {
  if (!coachPerformanceItems || !coachPerformanceItems.length) {
    return (
      <WidgetEmptyPlaceholder
        title="No data yet"
        icon={<BarChartRoundedIcon />}
        text={
          <>
            Data will appear here as activity
            <br />
            becomes available
          </>
        }
      />
    );
  }

  return (
    <div className={classes.itemsList}>
      {coachPerformanceItems.map((item, index) => {
        const isLastItem = index === coachPerformanceItems.length - 1;
        return (
          <Fragment key={item.id}>
            <CoachPerformanceItem item={item} />
            {!isLastItem && <Divider className={classes.divider} />}
          </Fragment>
        );
      })}
    </div>
  );
};

export { CoachPerformanceList };
